import React, { Children } from 'react';

import { GroupWrapper, RowCell, RowWrapper } from './InputGroup.styles';
import type { InputGroupProps, InputGroupRowProps } from './InputGroup.types';

function Row({ children }: InputGroupRowProps) {
  const childArray = Children.toArray(children);
  const multiChild = childArray.length > 1;

  return (
    <RowWrapper $multiChild={multiChild}>
      {multiChild ? childArray.map((child, i) => <RowCell key={i}>{child}</RowCell>) : children}
    </RowWrapper>
  );
}

function InputGroupRoot({ children, error }: InputGroupProps) {
  return <GroupWrapper $error={error}>{children}</GroupWrapper>;
}

export const InputGroup = Object.assign(InputGroupRoot, { Row });
